<script lang="ts" setup>
import {useRequiredSelectRule} from '@/ts/composables/pure/use-input-rules';
import {useSelectInput} from '@/ts/composables/pure/use-select-input';
import {computed} from 'vue';
import type {QuasarOption} from '@/ts/types/component/select-multichoice';
import {useI18n} from 'vue-i18n';
import {EducationLevelDTO} from '@/ts/types/dto/sign-in-dto';

const model = defineModel<EducationLevelDTO | null>();
const {t: $t} = useI18n();

const educations = computed<QuasarOption<EducationLevelDTO>[]>(() => Object.values(EducationLevelDTO).map(value => ({
  label: $t(value as string),
  value,
})));

const requiredRule = useRequiredSelectRule();

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const {
  options,
  inputValue,
  value,
  filterFn,
  onInputValue,
} = useSelectInput(educations, model);
</script>
<template>
  <q-select
    v-model="value"
    use-input
    fill-input
    hide-selected
    input-debounce="0"
    :input-value="inputValue"
    :options="options"
    :label="$t('education_level')"
    name="education"
    :rules="[requiredRule]"
    @filter="filterFn"
    @input-value="onInputValue"
  />
</template>
